function setSearch() {

    $(".search_button").on("click", function () {
        $(".search-panel").fadeIn();
        $(this).next().show().css({
            display: "block"
        });
        $(this).hide();
    });

    $(".search_button_close").hide().on("click", function () {
        $(".search-panel").hide();
        $(this).prev().show();
        $(this).hide();
    });
}

$(document).ready(function ($) {
    setSearch();
});


if (typeof Handlebars != 'undefined') {
    Handlebars.registerHelper('if_even', function (conditional, options) {
        if ((conditional % 2) === 0) {
            return options.fn(this);
        } else {
            return options.inverse(this);
        }
    });
}